import { Component, input } from '@angular/core';
import { SelectionButtonComponent } from '@shared/components/challenges/elements/selection-button/selection-button.component';
import { UnselectionButtonComponent } from '@shared/components/challenges/elements/unselection-button/unselection-button.component';
import { WinCardComponent } from '@shared/components/challenges/elements/win-card/win-card.component';
import { CampaignPhase, SubType } from '@shared/constants';
import { FrequencyChallenge } from '@shared/factory';
import { FrequencyChallengeNinthVariantConfig } from '@shared/models';
import { VariableReplacementPipe } from '@shared/pipes';

import { FrequencyBaseClass } from '../frequency.base.class';

@Component({
  selector: 'b2c-variant9',
  styleUrl: './variant9.component.scss',
  templateUrl: './variant9.component.html',
  imports: [
    WinCardComponent,
    VariableReplacementPipe,
    SelectionButtonComponent,
    UnselectionButtonComponent,
  ],
})
export class Variant9Component extends FrequencyBaseClass {
  /** See {@link Variant6Component.previewSelected}. */
  previewSelected = input<boolean>(false);

  challenge = input.required<FrequencyChallenge>();
  config = input.required<FrequencyChallengeNinthVariantConfig>();

  withShadow = input<boolean>(true);
  isBisCampaign = input<boolean>(false);
  isEventChallenge = input<boolean>(false);
  phase = input<CampaignPhase>(CampaignPhase.CURRENT);

  public readonly SubType: typeof SubType = SubType;
}
